import { createFileRoute } from '@tanstack/react-router'

import { QuestPlayerPage } from '@/features/quests'
import type { QuestShellVariant } from '@/features/quests/model/types'

type QuestPlayerSearch = {
  shell: QuestShellVariant
}

export const Route = createFileRoute('/_event/quests/$uid')({
  validateSearch: (search: Record<string, unknown>): QuestPlayerSearch => ({
    shell: search.shell === 'immersive' ? 'immersive' : 'frame'
  }),
  component: QuestPlayerRoute
})

function QuestPlayerRoute() {
  const { uid } = Route.useParams()
  const { shell } = Route.useSearch()

  return <QuestPlayerPage questUid={uid} shellVariant={shell} />
}
